import { getPaymentTypes } from 'pando-constants';

const mutation = {
  initialReset(state) {
    state.list = [];
    state.filter = {};
    state.filter.page_number = 1;
    state.filter.page_limit = 25;
    state.hasEmpty = false;
    state.isLoading = false;
    state.invoiceDetails = {};
  },

  paginationCheck(state, status) {
    state.isPaginating = status;
  },

  SET_LOADING(state, status) {
    state.isLoading = status;
  },
  SET_FREIGHT_CHARGE_LOADING(state, status) {
    state.isBaseFreightLoading = status;
  },

  SET_LIST(state, data) {
    const result = (state.filter.page_number > 1) ? state.list.concat(data) : data;
    state.list = result;
    if (data.length) {
      state.filter.page_number += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  SET_LIST_INVOICE(state, data) {
    const result = (state.filter.page_number > 1) ? state.list.concat(data.data) : data.data;
    state.list = result;
    if (data.is_empty_data) {
      state.hasEmpty = true;
    } else {
      state.filter.page_number += 1;
      state.hasEmpty = false;
    }
  },

  SET_INDENTS(state, data) {
    state.indentslist = data;
  },

  setIsDedicatedTruck(state, data) {
    let currResult = false;
    if (data.data.payments && data.data.payments.length) {
      currResult = data.data.payments.every(payment => payment.type ===
        getPaymentTypes().DEDICATED_TRUCK_WITH_INDENT_PAYMENT);
    }
    if (state.isDedicatedTruck === null) {
      state.isDedicatedTruck = currResult;
    } else {
      state.isDedicatedTruck = state.isDedicatedTruck || currResult;
    }
  },
  setInvoiceDetails(state, data) {
    const { params } = data;
    const depotDetails = state.depotWiseDetails && state.depotWiseDetails[params.depot_id];
    if (params.page_number === depotDetails.page_number) {
      if (data.data.payments && data.data.payments.length) {
        if (state.invoiceDetails && state.invoiceDetails.data) {
          data.data.sez_enabled = state.invoiceDetails.data.sez_enabled
              && data.data.sez_enabled;
        }
        const result = (state.filter.page_number > 1) ?
          state.invoiceDetails.payments.concat(data.data.payments) : data.data.payments;
        state.invoiceDetails = { ...data, ...state.invoiceDetails };
        state.invoiceDetails.payments = result;
        state.filter.page_number += 1;
        state.hasEmpty = false;
      } else {
        state.hasEmpty = true;
      }
    }
  },

  setTotalSystemCharges(state, data) {
    state.totalSystemCharges = data;
  },

  setTotalTransporterCharges(state, data) {
    state.totalTransporterCharges = data;
  },

  setTansporterTotalFreightCharge(state, data) {
    state.transporterTotalFreightCharge = data;
  },

  setTempCharges(state, data) {
    state.tempCharges = data;
  },

  setInvoiceMeta(state, data) {
    const invoiceDetails = state.invoiceDetails;
    if (invoiceDetails) {
      invoiceDetails.meta = data;
    }
    state.invoiceDetails = invoiceDetails;
  },

  updateTempCharges(state, data) {
    const obj = {};
    obj[data.index] = { ...state.tempCharges[data.index], ...data.value };
    state.tempCharges = { ...state.tempCharges, ...obj };
  },

  clearTempCharges(state) {
    state.tempCharges = {};
  },

  setPage(state, page) {
    state.filter.page_number = page;
  },

  setHasEmpty(state, data) {
    state.hasEmpty = data;
  },

  setFreightBillDetails(state, data) {
    state.freightBillDetails = data;
  },
  setAttachmentAvailable(state, data) {
    state.isAttachmentAvailable = data;
  },
  setDepotDetails(state, data) {
    const depotDetail = data.depot_details
    const depotCharges = data.depot_wise_charges
    if (data && data.depot_details) {
      state.depotWiseDetails = Object.keys(depotDetail).reduce((acc, depot) => {
        acc[depot] = {
          ...depotDetail[depot],
          page_number: 1,
          loaded_payments: 0,
          has_empty: false,
        };
        if(depotCharges && depotCharges[depot]){
          acc[depot].depot_total = depotCharges[depot][0].total
        }
        return acc;
      }, {});
    }
  },
  updateDepotPagination(state, params) {
    const { depot_id: depotId, payment_count: paymentCount, page_number: pageNumber } = params;
    const depotWiseDetails = state.depotWiseDetails;
    if (depotWiseDetails[depotId] && depotWiseDetails[depotId].page_number === pageNumber) {
      depotWiseDetails[depotId].page_number += 1;
      depotWiseDetails[depotId].loaded_payments += paymentCount;
      if (!paymentCount) {
        depotWiseDetails[depotId].has_empty = true;
      }
    }
    state.depotWiseDetails = depotWiseDetails;
  },
  clearDepotDetails(state, data) {
    state.depotWiseDetails = data;
  },
  cancelInvoices(state, data) {
    state.list.map((item) => {
      if (data.indexOf(item.id) !== -1) {
        item.status = 10;
      }
    });
  },

  updateRetryFreightInvoice(state, data) {
    const newList = state.list.reduce((acc, invoice) => {
      const invoiceData = invoice;
      if (invoiceData.id === data) {
        invoiceData.retry_freight_invoice_posting = {
          should_retry: false,
        };
      }
      acc.push(invoiceData);
      return acc;
    }, []);
    state.list = newList;
  },

  updateSignatureStatus(state, data) {
    const index = state.list.findIndex(invoice => invoice.id === data.invoiceId);
    if (index !== -1) {
      state.list[index].invoice_signature_status = data.status;
    }
  },
};

export default mutation;
